// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__lifecycleIntegration__hideMicroFrontend{visibility:hidden}", "",{"version":3,"sources":["webpack://./../../../../src/shellSide/integration/lifecycleIntegration/lifecycleIntegration.module.scss","webpack://./../../platform/@jutro/micro-frontends/shellSide/integration/lifecycleIntegration/lifecycleIntegration.module.css"],"names":[],"mappings":"AAAA,8CACE,iBCCF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hideMicroFrontend": "jut__lifecycleIntegration__hideMicroFrontend"
};
export default ___CSS_LOADER_EXPORT___;
